import charSprite from '../images/character.png'

export const char = {
    size: {
        width: 100,
        height: 100
    },
    img: charSprite,
    zIndex: 100
}

export const camera = {
    length: 200
}